import React from 'react'
import {cx} from '@emotion/css'
import isChromatic from 'chromatic'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'

import {
  BottomCTAWrapper,
  DESKTOP_MAX_WIDTH,
  GalleryDetailsPanel,
  MainContentPanel,
  StyledPopUp,
  Wrapper
} from './styles'

interface Props {
  isVisible: boolean
  dataId?: string
  className?: string
  headerCenterContent?: React.ReactNode
  headerStartContent?: React.ReactNode
  mainContent?: React.ReactNode
  sidePanelContent?: React.ReactNode
  primaryRoomOffer?: React.ReactNode
  isSidePanelVisible?: boolean
  bottomCTA?: React.ReactNode
  onClose: () => void
}

export const AccommodationContentOverlay: React.FC<Props> = ({
  isVisible,
  onClose,
  dataId,
  className,
  headerCenterContent,
  headerStartContent,
  mainContent,
  sidePanelContent,
  primaryRoomOffer,
  isSidePanelVisible,
  bottomCTA
}) => {
  if (!isVisible) return null

  return (
    <StyledPopUp
      isOpen={isVisible}
      closeAction={onClose}
      dataId={dataId}
      className={cx(isChromatic() && '--is-chromatic', className)}
      width={DESKTOP_MAX_WIDTH}
      navBarProps={{
        centerContent: headerCenterContent,
        startContent: headerStartContent,
        withDivider: true
      }}
      noPaddings
    >
      <Wrapper>
        <MainContentPanel>{mainContent}</MainContentPanel>
        {isSidePanelVisible && (
          <GalleryDetailsPanel>
            {sidePanelContent}
            {primaryRoomOffer && (
              <Box
                position="sticky"
                bottom="0"
                left="0"
                width="100%"
                backgroundColor="background.neutral.primary"
              >
                <Divider />
                <Box
                  paddingTop="s400"
                  paddingBottom="s400"
                  paddingLeft="s500"
                  paddingRight="s500"
                >
                  {primaryRoomOffer}
                </Box>
              </Box>
            )}
          </GalleryDetailsPanel>
        )}
        {bottomCTA && !isSidePanelVisible && (
          <BottomCTAWrapper>{bottomCTA}</BottomCTAWrapper>
        )}
      </Wrapper>
    </StyledPopUp>
  )
}
